import React from "react";

const PattenSyntextInfo = (
  <div>
    <ul>
      <li>The standard IUPAC one letter code for the amino acids (for example: "P" stands Proline) and nucleotides code (for example: "C" stands for "cytosine") should be used to define a patten.</li>
      <li>[ ] with listed amino acids or nucleotides letters means that the listed letters are allowed in this position. Charactor "," in between letters are optional. For example: [A,T,C] or [ATC] means that "A" or "T" or "C" are allowed in this position.</li>
      <li>{`{ }`} with listed amino acids or nucleotides letters means that the listed letters are NOT allowed in this position. Charactor "," in between letters are optional. For example: {`{DE} or {D,E}`} means that "D" or "E" should not be allowed in this position.</li>
      <li>The wildcard "x" means that any amino acid or nucleotide in this position is accepted.</li>
      <li>{`Each element in a pattern could be separated from its neighbor by a '-'. This is optional. For example, [A,T]-x-{C,A}, [A,T]x{C,A}, [AT]-x-{CA}, and [AT]x{CA} are identical patterns.`}</li>
      <li>Repetition of an element in multiple continuous positions can be represented by following that element with a "(number of repeats)" or a "(minimum repeates, maximium repeates)". For example:</li>
      <ul>
        <li>A(3) stands for AAA.</li>
        <li>T(2,5) stands TT, TTT, TTTT, or TTTTT.</li>
      </ul>
      <li>{`User should add a "^" or "<" to indicate that the pattern must started with N-terminal (or 5' terminal).`}</li>
      <li>{`User should add a "$" or ">" to indicate that the pattern must ended with C-terminal (or 3' terminal).`}</li>
    </ul>
  </div>
  );

export default PattenSyntextInfo;